import { createSlice } from '@reduxjs/toolkit'
import { saveState } from '../../localStorage'

export const betaAuth = createSlice({
  name: 'betaAuth',
  initialState: {
    showAccessPortal: false,
    invalidAccessKey: false,
    accessCode: null,
    betaChecked: false,
  },
  reducers: {
    setShowAccessPortal: (state, action) => {
      state.showAccessPortal = action.payload
      saveState("betaAuth", state)
    },
    setInvalidAccessKey: (state, action) => {
      state.invalidAccessKey = action.payload
      saveState("betaAuth", state)
    },
    setAccessCode: (state, action) => {
      state.accessCode = action.payload
      saveState("betaAuth", state)
    },
    setBetaChecked: (state, action) => {
      state.betaChecked = action.payload
      saveState("betaAuth", state)
    },
  }
})

export const { setShowAccessPortal, setInvalidAccessKey, setAccessCode, setBetaChecked } = betaAuth.actions

export default betaAuth.reducer